import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../components/framework';
import Link from '../components/framework/link';
import useTranslation from '../hooks/use_translation';

const PageNotFound = ({ location }) => {
	const { t } = useTranslation('page_not_found');

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
		>
			<div className="container mt-3 pt-lg-5" id="content">
				<h1>{t('t1')}</h1>
				<p>{t('t2')}</p>
				<p>
					<Link to="/">{t('t3')}</Link>
				</p>
			</div>
		</Framework>
	);
};

PageNotFound.propTypes = {
	location: PropTypes.object.isRequired,
};

export default PageNotFound;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
